import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import Process from "@/components/Process";
import BookingSection from "@/components/BookingSection";
import Footer from "@/components/Footer";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";

const Home = () => (
  <div className="relative min-h-screen bg-ink text-white overflow-x-clip">
    <div className="grain" aria-hidden="true" />
    <Nav />
    <main>
      <Hero />
      <Marquee />
      <Services />
      <Process />
      <BookingSection />
    </main>
    <Footer />
    <FloatingWhatsApp />
  </div>
);

export default Home;
